<template>
  <aside
    class="sidebar"
    :class="getClasses"
  >
    <user />
    <div class="sidebar__section-label">Рабочее пространство</div>

    <navigation @navigate="onNavigate" />
  </aside>
</template>

<script>
import User from './components/user'
import Navigation from './components/navigation'

export default {
  name: 'Sidebar',
  components: {
    User,
    Navigation
  },
  props: {
    isOpenSidebar: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onNavigate () {
      if (window.matchMedia('(max-width: 768px)').matches && this.isOpenSidebar) {
        this.$emit('toggle-sidebar')
      }
    }
  },
  computed: {
    getClasses () {
      return { 'sidebar--open': this.isOpenSidebar }
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
